import React from 'react'
import styled from 'styled-components'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { FpxBankElement } from 'react-stripe-elements'
import { colors, colorConstants, padding, paddingSizes } from '@jarvis.oddle/core/theme/default'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { P } from '@jarvis.oddle/core/components/Typo'

/**
 * To style the element, please refer to the following docs
 * https://stripe.com/docs/js/appendix/style
 */
const StyledFpxBankElement = styled(FpxBankElement).attrs(() => ({
  style: {
    base: {
      padding: `${padding[paddingSizes.medium]} ${padding[paddingSizes.small]}`,
      fontSize: '1.05em'
    }
  }
}))`
  /** The rule bellow will be applied to the element's container */
  border: 1px ${props => props.isError ? colorConstants.red : props.isFocus ? colors.text : colors.separator} solid;
  background-color: ${colorConstants.white};
`

/**
 * This component will render a dropdown that contains
 * list of participating banks
 */
const StripeFPXElement = ({
  isError,
  onCardChange,
  onStripeReady
}: {
  isError: boolean
  onCardChange
  onStripeReady
  errorCard
}): JSX.Element => {
  const { t } = React.useContext(TranslationContext)

  return (
    <React.Fragment>
      <P bold>{t('Select bank')}</P>
      <StyledFpxBankElement
        isError={isError}
        accountHolderType='individual'
        onChange={onCardChange}
        onReady={onStripeReady} />
    </React.Fragment>
  )
}

export default StripeFPXElement
